export default function getClonedArray(arr) {
	return JSON.parse(JSON.stringify(arr));
}
